// 设备状态文本  待验 待绑 已绑 停用

import { ENUM_DEVICE_WAY } from '@/common/enum/forward/device'

// 注意：text 字段存 i18n key 字符串（而非预翻译值），由 Button.vue 模板内调用 $t(item.text) 实时响应语言切换
export default [
  {
    id: 1,
    icon: '',
    vHas: [],
    text: 'public.unconfirm',
    method: 'changeWayFn',
    way: ENUM_DEVICE_WAY.UNCONFIRM
  },
  {
    id: 2,
    icon: '',
    vHas: [],
    text: 'public.unbind',
    method: 'changeWayFn',
    way: ENUM_DEVICE_WAY.UNBIND
  },
  {
    id: 3,
    icon: '',
    vHas: [],
    text: 'public.bind',
    method: 'changeWayFn',
    way: ENUM_DEVICE_WAY.BIND
  },
  {
    id: 4,
    icon: '',
    vHas: [],
    text: 'device.stop_use',
    method: 'changeWayFn',
    way: ENUM_DEVICE_WAY.STOP
  }
]
